import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import { FaPlay } from "react-icons/fa";

import blogArray from "../../DataJS/blogNews.js";

const BlogDetails = () => {
  const [blogs, setBlogs] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setBlogs(blogArray);
  }, []);

  const findBlogDetails = blogs.find((blog) => blog.id === parseInt(id));

  return (
    <Wrapper>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">
                    News & Media Details
                  </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>News & Media Details</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="rs-postbox-area section-space"
        style={{ paddingTop: "50px" }}
      >
        <span
          className="rs-section-subtitle has-theme-orange justify-content-center text-capitalize"
          style={{ marginBottom: "40px" }}
        >
          <FaPlay color="#EA5501" size={12} />
          Our Latest Media News & Events Details
        </span>
        <div className="container">
          <div className="row g-5">
            <div className="col-xl-12 col-lg-12">
              <div className="rs-postbox-wrapper">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        // src="/assets/images/blog/post/blog-post-01.png"
                        src={findBlogDetails && findBlogDetails.img}
                        alt="imagee"
                      />
                    </Link>
                    {/* <div className="rs-postbox-tag">
                      <Link to="/blog-details">Company</Link>
                    </div> */}
                  </div>
                  <div className="rs-postbox-content">
                    <div className="rs-postbox-meta-list">
                      <div className="rs-postbox-meta-item">
                        {/* <span className="rs-meta-text">
                          By
                          <Link className="meta-author" to="/blog-details">
                            Industrie
                          </Link>
                        </span> */}
                      </div>
                      <div className="rs-postbox-meta-item">
                        <span className="rs-postbox-meta-text">
                          <Link to="#">
                            {findBlogDetails && findBlogDetails.date}
                          </Link>
                        </span>
                      </div>
                    </div>
                    <h3 className="rs-postbox-title">
                      <Link to="#">
                        {findBlogDetails && findBlogDetails.title}
                      </Link>
                    </h3>
                    <div className="rs-postbox-text">
                      <p>{findBlogDetails && findBlogDetails.description}</p>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .rs-postbox-meta-list {
    display: flex;
    align-items: center;
    gap: 0 !important;
  }

  .rs-postbox-meta-item::before {
    display: none !important;
    content: none !important;
  }
`;

export default BlogDetails;
